const MarkerLessSceneInit = () => {
  return (
    <a-scene
      embedded
      webar-scene
      renderer="logarithmicDepthBuffer: true; colorManagement: true; precision: mediump"
      vr-mode-ui="enabled: false"
      xr-mode-ui="enabled: false"
      physics="iterations: 1;"
      xrweb="allowedDevices: any"
      gltf-model="dracoDecoderPath: https://rhym.s3.ap-south-1.amazonaws.com/draco/"
      // cursor="fuse: false; rayOrigin: mouse;"
      // raycaster="objects: .clickable, .cursor-clickable"
      // arjs="trackingMethod: best; sourceType: webcam; debugUIEnabled: false;"
      // screenshot="width: 390; height: 699;"
      id="scene"
      gesture-detector
    >
      {/* <a-sky color="#E7E7E7"></a-sky> */}
      <a-light type="ambient" color="#ffffff"></a-light>

      {/* Add directional light */}
      <a-light type="directional" position="-1 2 1"></a-light>
      {/* <a-entity position="0 2 3.7">
        <a-entity camera look-controls wasd-controls fov="80"></a-entity>
      </a-entity> */}

      {/* <a-entity grid-helper="size: 50; divisions: 20"></a-entity> */}
      <a-assets></a-assets>

      <a-camera
        id="camera"
        // arjs-look-controls=" reverseMouseDrag: false; touchEnabled: false;smoothingFactor: 0.5"
        // look-controls-enabled="false"
        // wasd-controls-enabled="false"
        position="0 2 10"
        tone-mapping="algorithm: reinhard;"
        // look-controls="enabled: false"
        // wasd-controls="enabled: false"
      ></a-camera>
      {/*
      <a-entity
        camera
        id="camera"
        position="0 2 10"
        // rotation="-90 0 0"
        // cursor="rayOrigin: mouse"
        // raycaster="objects: .clickable;"
      ></a-entity> */}

      <a-entity
        id="cursor"
        gltf-model="url(https://rhym.s3.ap-south-1.amazonaws.com/AR/markerless/v1/assets/tap.glb)"
        look-at="#camera"
        scale="2 2 2"
        material="shader: flat"
        animation-mixer=" loop: repeat"
        reflections="type: static"
        visible="false"
      >
        <a-plane
          rotation="-90 0 0"
          scale="1.6 3.3 1"
          material="src: #icon; opacity: 0; roughness: 0; metalness: 0; transparent: true"
        ></a-plane>
      </a-entity>

      <a-entity
        id="webar_stage"
        grid="size: 10; divisions: 10; color: #00F; opacity: 0.3"
        position="0 0 0"
      >
        <a-entity>
          <a-entity id="entity_elements" visible="false"></a-entity>
        </a-entity>
      </a-entity>

      <a-box
        id="ground"
        scale="1000 2 1000"
        position="0 -1 0"
        material="shader: shadow; transparent: true; opacity: 0.4"
        shadow
      ></a-box>
    </a-scene>
  );
};

export default MarkerLessSceneInit;
